<template>
  <KnowledgebaseLayout
    :categories="categories"
    :knowledgebase-path="knowledgebasePath"
    :breadcrumbs="breadcrumbs"
    :page-title="pageTitle"
    :search-placeholder="t.search_knowledgebase"
    :all-categories-label="t.all_categories"
    :search-action="searchPath"
  >
    <template #default>
      <!-- Empty State -->
      <v-row v-if="visibleCategories.length === 0" justify="center">
        <v-col cols="12" class="text-center py-8">
          <v-icon size="64" color="grey-lighten-1">mdi-folder-open-outline</v-icon>
          <p class="text-h6 mt-4 text-grey">{{ t.no_categories }}</p>
        </v-col>
      </v-row>

      <!-- Categories and Documents -->
      <v-row v-else class="kb-content">
        <v-col cols="12" lg="9" class="kb-main-col">
          <CategoryCard
            v-for="category in visibleCategories"
            :key="category.id"
            :category="category"
            :expanded="openPanels.includes(category.id)"
            :show-more-link="true"
            :translations="t"
            @toggle="togglePanel(category.id)"
          />
        </v-col>
      </v-row>
    </template>
  </KnowledgebaseLayout>
</template>

<script>
import KnowledgebaseLayout from './KnowledgebaseLayout.vue'
import CategoryCard from './CategoryCard.vue'

export default {
  name: 'KnowledgebasePage',
  components: {
    KnowledgebaseLayout,
    CategoryCard
  },
  props: {
    categoriesData: {
      type: Array,
      default: () => []
    },
    pageTitle: {
      type: String,
      default: 'Knowledge Base'
    },
    breadcrumbsData: {
      type: Array,
      default: () => []
    },
    translations: {
      type: Object,
      default: () => ({})
    },
    knowledgebasePath: {
      type: String,
      default: '/categories'
    },
    searchPath: {
      type: String,
      default: '/result'
    }
  },
  data() {
    return {
      categories: [],
      openPanels: []
    }
  },
  computed: {
    t() {
      return {
        knowledgebase: this.translations.knowledgebase || 'Knowledge Base',
        search_knowledgebase: this.translations.search_knowledgebase || 'Search Knowledge Base',
        no_categories: this.translations.no_categories || 'No categories available',
        more_documents: this.translations.more_documents || 'More Documents',
        home: this.translations.home || 'Home',
        all_categories: this.translations.all_categories || 'All Categories'
      }
    },
    breadcrumbs() {
      return [
        { title: this.t.home, href: '/' },
        { title: this.pageTitle, disabled: true }
      ]
    },
    visibleCategories() {
      return this.categories.filter(cat => cat.docs && cat.docs.length > 0)
    }
  },
  mounted() {
    this.categories = this.categoriesData || []

    if (this.categories.length > 0) {
      this.openPanels = [this.categories[0].id]
    }
  },
  methods: {
    togglePanel(categoryId) {
      const index = this.openPanels.indexOf(categoryId)
      if (index > -1) {
        this.openPanels.splice(index, 1)
      } else {
        this.openPanels.push(categoryId)
      }
    }
  }
}
</script>

<style scoped>
.kb-content {
  padding: 0;
}

.kb-main-col {
  padding-right: 0 !important;
}

@media (max-width: 959px) {
  .kb-main-col {
    padding: 0 !important;
  }
}
</style>
